import { render, staticRenderFns } from "./DefaultProjectImageNew.vue?vue&type=template&id=4def83c8&scoped=true"
import script from "./DefaultProjectImageNew.vue?vue&type=script&lang=ts"
export * from "./DefaultProjectImageNew.vue?vue&type=script&lang=ts"
import style0 from "./DefaultProjectImageNew.vue?vue&type=style&index=0&id=4def83c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4def83c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4def83c8')) {
      api.createRecord('4def83c8', component.options)
    } else {
      api.reload('4def83c8', component.options)
    }
    module.hot.accept("./DefaultProjectImageNew.vue?vue&type=template&id=4def83c8&scoped=true", function () {
      api.rerender('4def83c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/DefaultProjectImageNew.vue"
export default component.exports